import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { Actions, Select, Store, ofActionDispatched, ofActionSuccessful } from "@ngxs/store";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    NotesModel,
    TourModel,
    VehicleEventsModel,
    VehicleModel,
    TourHistoryModel,
    DriverTrackingClient,
    GeofenceLocationModel,
    GeofenceReplayMarkerModel,
    HistoryClient,
    LookupsClient,
    LookupModel,
} from "@core/services/api.service";
import { ActivatedRoute } from "@angular/router";
import { Navigate } from "@ngxs/router-plugin";
import { Observable, Subject, merge } from "rxjs";
import { map, switchMap, take, takeUntil } from "rxjs/operators";
import {
    GetNotesAction,
    GetRouteByTourIdAction,
    GetTourByIdAction,
    GetTourByIdSuccessAction,
    LoadTourUpdateHistoryAction,
    UpdateETAAction,
    UpdateETAFailAction,
    UpdateETASuccessAction,
} from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { Location } from "@angular/common";
import {
    GetVehicleByIdAction,
    GetVehicleEventsAction,
    GetVehicleLocFromEventAction,
} from "@ngxs-store/vehicles-store/vehicles.action";
import { VehiclesState } from "@ngxs-store/vehicles-store/vehicles.state";
import { ManagedToursState } from "@ngxs-store/managed-tour-store/managed-tour.state";
import { DataSourceConfig } from "@core/models";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { LatLngLiteral } from "@agm/core";
import { Subject as SignalRSubject } from "@microsoft/signalr";
import { EditContactPersonDialogComponent } from "@shared/components/edit-contact-person-dialog/edit-contact-person-dialog.component";
import { SubjectSubscription } from "@microsoft/signalr/dist/esm/Utils";
import { ConfirmationDialogComponent } from "@shared/components/confirmation-dialog/confirmation-dialog.component";
import { ConsignmentStatusDatetimeDialogComponent } from "@shared/components/consignment-status-datetime-dialog/consignment-status-datetime-dialog.component";
import { AddVehicleDialogComponent } from "@shared/components/add-vehicle-dialog/add-vehicle-dialog.component";
import { AddDriverDialogComponent } from "@shared/components/add-driver-dialog/add-driver-dialog.component";
import {
    SendConsignmentStatusAction,
    SendConsignmentStatusSuccessAction,
    SendConsignmentStatusFailAction,
    ReportParcelCountDiscrepancyAction,
    ReportParcelCountDiscrepancySuccessAction,
    ReportParcelCountDiscrepancyFailAction
} from "@ngxs-store/driver-tracking-store/driver-tracking.actions";
import { DriverTrackingState } from "@ngxs-store/driver-tracking-store/driver-tracking.state";
import { SendConsignmentStatusCommand, ReportParcelCountDiscrepancyCommand } from "@core/services/api.service";
import { ReportDelayCommand } from "@core/services/api.service";
import { ViewDocumentsDialogComponent } from "@shared/components/view-documents-dialog/view-documents-dialog";
import { ReportParcelCountDiscrepancyDialogComponent, ReportParcelCountDiscrepancyDialogResult } from "@shared/components/report-parcel-count-discrepancy-dialog/report-parcel-count-discrepancy-dialog.component";
import { EscalationChatDialogComponent } from "@shared/components/escalation-chat-dialog/escalation-chat-dialog.component";
import { ReportDelayDialogComponent } from "@shared/components/report-delay-dialog/report-delay-dialog.component";
import { UpdateEtaDialogComponent } from "@shared/components/update-eta-dialog/update-eta-dialog";

@Component({
    selector: "app-view-tour-details",
    templateUrl: "./view-tour-details.component.html",
    styleUrls: ["./view-tour-details.component.scss"],
})
export class ViewTourDetailsComponent implements OnInit, OnDestroy, OnChanges {
    @Select(VehiclesState.getVehicleEventsByTourId) vehicleHistory$: Observable<
        VehicleEventsModel[]
    >;
    @Input() vehicleHistory: VehicleEventsModel[];

    @Select(VehiclesState.getVehicleLocFromEvent)
    vehicleLoc$: Observable<VehicleEventsModel>;
    @Select(DriverTrackingState.getIsSendingConsignmentStatus)
    isSendingConsignmentStatus$: Observable<boolean>;
    @Select(DriverTrackingState.getIsReportingParcelCountDiscrepancy)
    isReportingParcelCountDiscrepancy$: Observable<boolean>;
    @Select(ManagedToursState.getTourUpdateHistory)
    tourUpdateHistory$: Observable<TourHistoryModel[]>;
    @Input() vehicleLoc: VehicleEventsModel;
    @Output() updateDataSourceConfig = new EventEmitter<DataSourceConfig>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    detail: TourModel;
    vehicleDet: VehicleEventsModel;
    notes: NotesModel[] = [];
    lat: number;
    lng: number;
    imageUrl: string;
    //collection and vehicleId
    collectionLat: number;
    collectionLng: number;
    vehicleId: number;
    routeData: string = "";
    polylinePoints: Array<{ lat: number; lng: number }> = [];
    redPolylinePoints: Array<{ lat: number; lng: number }> = [];
    bmwVehicleMarkerEvents: VehicleEventsModel[] = [];
    bmwVehiclePolylinePoints: Array<{ lat: number; lng: number }> = [];
    private unsubscribe$ = new Subject();
    selectedFilterBy: string = "";
    tourId: number;
    mapCenter: LatLngLiteral = { lat: 48.858093, lng: 2.294694 };
    markers: Array<{ lat: number; lng: number }> = [];
    dataSource: MatTableDataSource<VehicleEventsModel>;
    bmwHistory: TourHistoryModel[] = [];
    geofenceZones: GeofenceLocationModel[] = [];
    replayMarkers: GeofenceReplayMarkerModel[] = [];
    showBmwGeofences = false;
    hasLoadedBmwGeofences = false;
    hasBmwReplayResult = false;
    isLoadingBmwGeofences = false;
    isReplayingBmwGeofencing = false;
    bmwMapZoom = 5;
    selectedReplayMarkerIndex: number | null = null;
    selectedMapFocus: { lat: number; lng: number } | null = null;

    private bmwMapInstance: any;
    private pendingMapFocus: { lat: number; lng: number; zoom: number } | null = null;

    private refreshDialogSubject = new SignalRSubject<void>();

    dataSourceConfig: DataSourceConfig = {
        name: "audit-table",
        columns: [
            "positionDateTime",
            "address",
            "countryCode",
            "zipCode",
            "nearestCity",
            "isManual",
        ],
        desktopModeColumns: [],
        mobileModeColumns: [],
        pageIndex: 10,
        pageSize: 10,
        pageSizeOptions: [10, 50, 100],
        filter: "",
        filterColumns: ["address", "countryCode"],
        selectedFilterColumns: ["address"],
        sortBy: "",
        sortByOrder: "",
    };

    // BMW job: progress stages and next-action button
    bmwStages: string[] = [
        "Order Accepted",
        "Collection",
        "Departure",
        "Transit",
        "Border",
        "Transit",
        "Arrival",
        "Delivered",
    ];

    /** Domestic: same journey without Border (and a single Transit leg in the UI). */
    bmwDomesticStages: string[] = [
        "Order Accepted",
        "Collection",
        "Departure",
        "Transit",
        "Arrival",
        "Delivered",
    ];
    private readonly bmwActionSequence: string[] = [
        "Arrive at Collection",
        "Goods Collected",
        "Depart Collection Point",
        "Arrived at Delivery Location",
        "Delivered",
    ];

    /** Domestic jobs skip ferry + port/border steps (go from departure straight to delivery). */
    private readonly bmwDomesticActionSequence: string[] = [
        "Arrive at Collection",
        "Goods Collected",
        "Depart Collection Point",
        "Arrived at Delivery Location",
        "Delivered",
    ];

    /** Aliases for domestic-only matching (no ferry/port groups). */
    private readonly bmwDomesticStatusAliases: string[][] = [
        ["arrive at collection", "arrived at collection", "on site collection"],
        ["goods collected", "pickup complete", "pickup"],
        ["depart collection point", "departed loading point", "departed loading", "departure"],
        ["arrived at delivery location", "arrival", "on site delivery", "arrived at delivery"],
        ["delivered", "delivery complete", "departed unloading point"],
    ];

    /** If status mentions international-only legs, domestic jobs still advance to "Arrived at Delivery". */
    private readonly bmwDomesticSkipAliases: string[] = [
        "boarded ferry",
        "entered tunnel",
        "disembarked ferry",
        "exited tunnel",
        "arrived at port",
        "departed port",
        "port / border",
        "arrived at border",
        "departed border",
    ];
    /** BMW history list pagination. */
    bmwHistoryPageIndex = 0;
    bmwHistoryPageSize = 10;
    bmwHistoryPageSizeOptions = [5, 10, 25, 50];
    isReportingDelay = false;
    transportOrderNumber: string | null = null;

    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private actions$: Actions,
        private location: Location,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private driverTrackingClient: DriverTrackingClient,
        private historyClient: HistoryClient,
        private lookupsClient: LookupsClient,
        private snackBar: MatSnackBar
    ) {
        const s = this.route.params.subscribe((params) => {
            // Access the optional parameter from the route
            if (params["filter"]) {
                this.selectedFilterBy = params["filter"];
                this.tourId = +params["id"];
            }
            if (params["transportOrderNumber"]) {
                this.transportOrderNumber = params["transportOrderNumber"];
            }
        });
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detail && changes.detail.currentValue) {
            const tour: TourModel = changes.detail.currentValue as TourModel;
            this.detail = tour;
        }

        if (changes.vehicleHistory && changes.vehicleHistory.currentValue) {
            const vehicleHistory: VehicleEventsModel[] = changes.vehicleHistory
                .currentValue as VehicleEventsModel[];
            this.updateVehicleEventMapLayers(vehicleHistory);
        }
    }

    page(pageEvent: PageEvent) {
        this.updateDataSourceConfig.emit({
            ...this.dataSourceConfig,
            pageIndex: pageEvent.pageIndex,
            pageSize: pageEvent.pageSize,
        });
    }

    sortChange(sortEvent: Sort) {
        this.updateDataSourceConfig.emit({
            ...this.dataSourceConfig,
            sortByOrder: sortEvent.direction,
            sortBy: sortEvent.active,
        });
    }

    ngOnInit() {
        this.dataSource = new MatTableDataSource<VehicleEventsModel>();
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.vehicleHistory$.subscribe((vehicle) => {
            this.vehicleHistory = vehicle;
            this.dataSource.data = vehicle.filter(
                (x) => x.disabled == false || x.disabled == null
            );
            this.updateVehicleEventMapLayers(vehicle);
        });

        this.tourUpdateHistory$.subscribe((history) => {
            this.bmwHistory = history || [];
        });

        this.route.params.subscribe((params) => {
            const tourId = +params["id"];
            this.tourId = tourId;
            if (params["transportOrderNumber"]) {
                this.transportOrderNumber = params["transportOrderNumber"];
            }

            const sub = this.actions$
                .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
                .subscribe((detail) => {
                    this.detail = detail.payload;
                    this.transportOrderNumber = this.detail?.transportOrderNumber ?? this.transportOrderNumber;
                    console.log(this.detail);
                    if (this.detail && this.detail.id) {
                        const id = this.detail.id;
                        this.lat = this.detail.destinationLatitude;
                        this.lng = this.detail.destinationLongitude;
                        this.markers.push({
                            lat: this.detail.destinationLatitude,
                            lng: this.detail.destinationLongitude,
                        });
                        this.collectionLat = this.detail.collectionLatitude;
                        this.collectionLng = this.detail.collectionLongitude;
                        this.markers.push({
                            lat: this.detail.collectionLatitude,
                            lng: this.detail.collectionLongitude,
                        });

                        // Get vehicle by vehicleId from tour
                        this.store.dispatch(
                            new GetVehicleLocFromEventAction(this.detail.id)
                        );

                        this.store
                            .select(VehiclesState.getVehicleLocFromEvent)
                            .subscribe((vehicleLoc) => {
                                this.vehicleDet = vehicleLoc;
                            });

                        //Get notes
                        this.store.dispatch(new GetNotesAction(id));

                        if (this.detail.isBmwJob && this.detail.id != null) {
                            this.store.dispatch(new LoadTourUpdateHistoryAction(this.detail.id));
                        }

                        // Get latest route
                        this.store.dispatch(new GetRouteByTourIdAction(id));
                        this.store
                            .select(ManagedToursState.getRouteByTourId)
                            .subscribe((vehicleDet) => {
                                this.routeData = vehicleDet?.routeData;
                            });

                        if (this.routeData) {
                            try {
                                const routeArray = JSON.parse(this.routeData);
                                this.markers.push(
                                    routeArray.map((point) => ({
                                        lat: point.lat,
                                        lng: point.lng,
                                    }))
                                );
                                // Extracting latitude and longitude from the parsed array
                                this.polylinePoints = routeArray.map(
                                    (point) => ({
                                        lat: point.lat,
                                        lng: point.lng,
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    "Error parsing routeData:",
                                    error
                                );
                            }
                        }

                        //Get vehicle events & plot
                        this.store.dispatch(new GetVehicleEventsAction(id));
                        this.store
                            .select(VehiclesState.getVehicleEventsByTourId)
                            .subscribe((events) => {
                                this.redPolylinePoints = events.map(
                                    (event) => ({
                                        lat: event.latitude,
                                        lng: event.longitude,
                                    })
                                );
                            });
                    }
                    this.redPolylinePoints.forEach((point) => {
                        this.markers.push(point);
                    });
                    console.log(this.markers);
                    if (this.markers.length) {
                        const sumLat = this.markers.reduce(
                            (sum, marker) => sum + marker.lat,
                            0
                        );
                        const sumLng = this.markers.reduce(
                            (sum, marker) => sum + marker.lng,
                            0
                        );

                        // Calculate the average latitude and longitude
                        this.mapCenter.lat = sumLat / this.markers.length;
                        this.mapCenter.lng = sumLng / this.markers.length;
                    } else {
                        this.mapCenter = { lat: 48.858093, lng: 2.294694 };
                    }
                    sub.unsubscribe();
                });

            this.store.dispatch(new GetTourByIdAction(tourId, this.transportOrderNumber));

            this.store
                .select((state) => state.Tour.notes)
                .subscribe((notes) => {
                    this.notes = notes;
                });
        });
    }

    getTruckIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/amco-main-bw.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/amco-red-truck.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/amco-green-truck.png";
    }

    getCollectionIcon(
        planned: string,
        eta?: Date,
        actual?: Date,
        type?: string
    ): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;
        const ActualDateTime = actual;
        const ETA = eta;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/collect-base.png";
        }

        if (type == "Delivery") {
            if (ActualDateTime > plannedDate) {
                // ETA or actual time is after the planned time
                return "./assets/images/collect-1.png";
            } else {
                return "./assets/images/collect-2.png";
            }
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/collect-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/collect-2.png";
    }

    getDeliveryIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/delivery-base.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/delivery-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/delivery-2.png";
    }

    private updateVehicleEventMapLayers(events: VehicleEventsModel[] = []): void {
        const sortedEvents = [...events]
            .filter((event) => event?.latitude != null && event?.longitude != null)
            .sort((a, b) => {
                const timeA = new Date(a.positionDateTime as any).getTime();
                const timeB = new Date(b.positionDateTime as any).getTime();

                if (Number.isNaN(timeA) && Number.isNaN(timeB)) {
                    return 0;
                }

                if (Number.isNaN(timeA)) {
                    return 1;
                }

                if (Number.isNaN(timeB)) {
                    return -1;
                }

                return timeA - timeB;
            });

        this.bmwVehicleMarkerEvents = sortedEvents;
        this.bmwVehiclePolylinePoints = sortedEvents
            .map((event) => ({ lat: event.latitude as number, lng: event.longitude as number }));
    }

    toggleBmwGeofencing(): void {
        if (this.showBmwGeofences) {
            this.showBmwGeofences = false;
            this.cdr.detectChanges();
            return;
        }

        if (this.hasLoadedBmwGeofences) {
            this.showBmwGeofences = true;
            this.cdr.detectChanges();
            return;
        }

        this.loadBmwGeofences(true);
    }

    replayBmwGeofencing(): void {
        if (!this.detail?.id || this.isReplayingBmwGeofencing) {
            return;
        }

        this.showBmwGeofences = true;
        this.hasBmwReplayResult = false;
        this.replayMarkers = [];

        if (!this.hasLoadedBmwGeofences) {
            this.loadBmwGeofences(true, true);
            return;
        }

        this.executeBmwGeofencingReplay();
    }

    focusReplayMarker(marker: GeofenceReplayMarkerModel, markerIndex: number): void {
        if (marker?.latitude == null || marker?.longitude == null) {
            return;
        }

        this.showBmwGeofences = true;
        this.selectedReplayMarkerIndex = markerIndex;
        this.selectedMapFocus = {
            lat: marker.latitude as number,
            lng: marker.longitude as number,
        };

        const zoom = this.getFocusZoomForMilestone(marker.milestoneName);
        this.focusMap(this.selectedMapFocus.lat, this.selectedMapFocus.lng, zoom);
        this.cdr.detectChanges();
    }

    isReplayMarkerSelected(markerIndex: number): boolean {
        return this.selectedReplayMarkerIndex === markerIndex;
    }

    getReplayMarkerTitle(marker: GeofenceReplayMarkerModel): string {
        const parts: string[] = [marker.milestoneName || 'Geofence Trigger'];
        if (marker.vehicleLicensePlate) { parts.push(`Reg: ${marker.vehicleLicensePlate}`); }
        if (marker.eventTime) { parts.push(`Time: ${new Date(marker.eventTime as any).toLocaleString()}`); }
        if (marker.nearestCity) { parts.push(`City: ${marker.nearestCity}`); }
        return parts.join('\n');
    }

    getEventTitle(event: VehicleEventsModel): string {
        const parts: string[] = [];
        if (event.vehicleLicensePlate) { parts.push(`Reg: ${event.vehicleLicensePlate}`); }
        if (event.positionDateTime) { parts.push(`Date: ${new Date(event.positionDateTime as any).toLocaleString()}`); }
        if (event.nearestCity) { parts.push(`City: ${event.nearestCity}`); }
        if (event.addressInfo) { parts.push(`Address: ${event.addressInfo}`); }
        return parts.join('\n') || 'Vehicle Event';
    }

    isBorderCrossed(milestoneName: string | undefined): boolean {
        return (milestoneName || '').toLowerCase() === 'border crossed';
    }

    isTunnelMilestone(milestoneName: string | undefined): boolean {
        const name = (milestoneName || '').toLowerCase();
        return name.includes('tunnel') || name.includes('customs');
    }

    isBorderMilestone(milestoneName: string | undefined): boolean {
        const name = (milestoneName || '').toLowerCase();
        return name.includes('border') || name.includes('port') || this.isTunnelMilestone(milestoneName);
    }

    getReplayMarkerIconUrl(milestoneName: string | undefined): string {
        return this.isBorderCrossed(milestoneName)
            ? 'assets/images/amco-error.png'
            : 'assets/images/amco-red-truck.png';
    }

    getReplayMarkerIconSize(milestoneName: string | undefined, isSelected = false): { width: number; height: number } {
        if (isSelected) {
            return { width: 70, height: 82 };
        }

        if (this.isBorderCrossed(milestoneName)) { return { width: 48, height: 48 }; }
        if (this.isTunnelMilestone(milestoneName)) { return { width: 54, height: 64 }; }
        return this.isBorderMilestone(milestoneName)
            ? { width: 60, height: 72 }
            : { width: 42, height: 52 };
    }

    getZoneColor(locationType: string | undefined): string {
        switch ((locationType || '').toLowerCase()) {
            case 'collection': return '#1976d2';
            case 'delivery':   return '#388e3c';
            case 'port':       return '#f57c00';
            case 'border':     return '#7b1fa2';
            case 'tunnel':     return '#00838f';
            default:           return '#455a64';
        }
    }

    getZoneFillColor(locationType: string | undefined): string {
        switch ((locationType || '').toLowerCase()) {
            case 'collection': return '#42a5f5';
            case 'delivery':   return '#66bb6a';
            case 'port':       return '#ffa726';
            case 'border':     return '#ab47bc';
            case 'tunnel':     return '#26c6da';
            default:           return '#78909c';
        }
    }

    getTimeDifference(targetDateTime: string, ETADateTime: Date): string {
        const targetDate = new Date(targetDateTime);

        if (!ETADateTime) {
            //no eta then Delta should be blank
            return "";
        } else {
            // If ETA exists, calculate time difference between ETA and planned end
            const ETADate = new Date(ETADateTime);
            const timeDifference = Math.abs(
                ETADate.getTime() - targetDate.getTime()
            );
            const minutesDifference = Math.floor(timeDifference / (1000 * 60));

            const hours = Math.floor(minutesDifference / 60);
            const minutes = minutesDifference % 60;

            if (hours === 0 && minutes === 0) {
                return "0 hrs";
            }

            let timeDifferenceString = "";

            if (hours > 0) {
                timeDifferenceString += hours + "hr ";
            }
            if (minutes > 0) {
                timeDifferenceString += minutes + "min";
            }

            return timeDifferenceString.trim();
        }
    }

    resetMap() {
        this.polylinePoints = [];
        this.redPolylinePoints = [];
        this.routeData = "";

        this.polylinePoints = [...this.polylinePoints];
        this.redPolylinePoints = [...this.redPolylinePoints];
    }

    onMapReady(map: any): void {
        this.bmwMapInstance = map;

        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(map);

        if (this.pendingMapFocus) {
            this.focusMap(this.pendingMapFocus.lat, this.pendingMapFocus.lng, this.pendingMapFocus.zoom);
            this.pendingMapFocus = null;
        }
    }

    goBack() {
        if (this.selectedFilterBy) {
            if(this.selectedFilterBy === 'ControlTowerShipments'){
                this.store.dispatch(
                    new Navigate(["/control-tower-live-map/"])
                );
            }else{
                this.store.dispatch(
                    new Navigate(["/tours/", { filter: this.selectedFilterBy }])
                );
            }

        } else {
            this.location.back();
        }
        this.resetMap();

        this.cdr.detectChanges();
    }

    editCustContact(email: string){
        const dialogRef = this.dialog.open(EditContactPersonDialogComponent, {
            data: { editTourId: this.tourId, emails: email }, disableClose: true, width: '1000px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));

            const sub1 = this.actions$
            .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
            .subscribe((successAction: GetTourByIdSuccessAction) => {
                if(successAction){
                    this.detail = successAction.payload;
                    this.refreshDialogSubject.next();
                    this.cdr.detectChanges();
                }

                sub1.unsubscribe();
            });
        });
    }

    editTrailerRegNumber(trailerRegNumber: string){
        const dialogRef = this.dialog.open(AddVehicleDialogComponent, {
           data: { id: this.detail.id, isEmail: false, redirectBack: true, isTrailerRegNumber: true, trailerRegNumber: trailerRegNumber, tourId: this.detail.tourId, transportOrderNumber: this.transportOrderNumber }, disableClose: true, width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.store.dispatch(new GetTourByIdAction(this.detail.tourId, this.transportOrderNumber));

            const sub1 = this.actions$
            .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
            .subscribe((successAction: GetTourByIdSuccessAction) => {
                if(successAction){
                    this.detail = successAction.payload;
                    this.refreshDialogSubject.next();
                    this.cdr.detectChanges();
                }

                sub1.unsubscribe();
            });
        });
    }

    editDriverDetails(driverName: string, cellphoneNumber: string){
        const dialogRef = this.dialog.open(AddDriverDialogComponent, {
            width: '500px',
            data: {
                amcoId: this.detail.id,
                isEditMode: true,
                existingDriverName: driverName,
                existingCellphoneNumber: cellphoneNumber
            },
            disableClose: true
          });



          dialogRef.afterClosed().subscribe(result => {
            if(result){

                const sub1 = this.actions$
                .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
                .subscribe((successAction: GetTourByIdSuccessAction) => {
                    if(successAction){
                        this.detail = successAction.payload;
                        this.refreshDialogSubject.next();
                        this.cdr.detectChanges();
                    }

                    sub1.unsubscribe();
                });
                this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
            }
        });
    }

    editCarrierContactEmail(email: string){
        const dialogRef = this.dialog.open(AddVehicleDialogComponent, {
           data: {
               id: this.detail.id,
               isEmail: false,
               isCarrierEmail: true,
               redirectBack: true,
               email: email,
               tourId: this.detail.tourId,
               transportOrderNumber: this.transportOrderNumber
            },
            disableClose: true,
            width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.store.dispatch(new GetTourByIdAction(this.detail?.tourId, this.transportOrderNumber));

            const sub1 = this.actions$
            .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
            .subscribe((successAction: GetTourByIdSuccessAction) => {
                if(successAction){
                    this.detail = successAction.payload;
                    this.refreshDialogSubject.next();
                    this.cdr.detectChanges();
                }

                sub1.unsubscribe();
            });
        });
    }

    deleteCustContact(){
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                id: this.tourId,
                modalTitle: 'Delete Contact Person Email',
                buttonType: 'Delete',
                confirmationText: `Are you sure you want to delete this Customer Contacts For Tracking?`
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result){

                const sub1 = this.actions$
                .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
                .subscribe((successAction: GetTourByIdSuccessAction) => {
                    if(successAction){
                        this.detail = successAction.payload;
                        this.refreshDialogSubject.next();

                        this.detail.customerContactEmail = '';
                        this.cdr.detectChanges();
                    }

                    sub1.unsubscribe();
                });
                this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getIcon(type: string, updatedBy: string): string {
        if (updatedBy == "ImportService") {
            return type == "Collection"
                ? "./assets/images/White-C.png"
                : "./assets/images/White-D.png";
        } else {
            return type == "Collection"
                ? "./assets/images/Green-C.png"
                : "./assets/images/Green-D.png";
        }
    }

    /** Current BMW progress stage index (0–7) derived from tour data (updateTypeName, latestAction, latestNote, dates). */
    get bmwCurrentStageIndex(): number {
        if (!this.detail) return 0;
        return this.getBmwStageFromDetail(this.detail);
    }

    private getBmwStatusText(d?: TourModel | null): string {
        if (!d) return "";

        return [d.updateTypeName, d.latestAction, d.latestNote]
            .filter((value): value is string => !!value && !!value.trim())
            .join(" ")
            .toLowerCase();
    }

    /** Stages shown in the progress bar (domestic omits Border). */
    get bmwDisplayStages(): string[] {
        return this.isDomesticOrderType(this.detail) ? this.bmwDomesticStages : this.bmwStages;
    }

    /**
     * Index into {@link bmwDisplayStages} for highlighting.
     * Domestic maps international stages 3–5 (transit / border / transit) onto one "Transit" step.
     */
    get bmwDisplayStageIndex(): number {
        const raw = this.bmwCurrentStageIndex;
        if (!this.isDomesticOrderType(this.detail)) {
            return raw;
        }
        if (raw <= 2) {
            return raw;
        }
        if (raw <= 5) {
            return 3;
        }
        if (raw === 6) {
            return 4;
        }
        return 5;
    }

    /**
     * Computes BMW stage (0–7) from tour data: updateTypeName, latestAction, latestNote, and dates.
     * This drives the progress bar and next-action button from the API payload.
     */
    private getBmwStageFromDetail(d: TourModel): number {
        if (!d) return 0;
        const statusText = this.getBmwStatusText(d);

        if (d.actualDeliveryDate || d.actualArrivalAtDeliveryDate) return 7;
        if (d.actualDepartureFromCollectionDate) {
            return d.actualArrivalAtDeliveryDate ? 7 : this.getBmwStageFromUpdateType(d, 3);
        }

        // Collection done: actualCollectionDate set and "Goods collected" in note/action → next is Departure (stage 2)
        if (d.actualCollectionDate || d.onsiteCollectionDateTime) {
            if (statusText.includes("goods collected") || statusText.includes("pickup")) {
                return 2;
            }
            return 1;
        }

        return this.getBmwStageFromUpdateType(d, 0);
    }

    private getBmwStageFromUpdateType(_d: TourModel, defaultStage: number): number {
        const name = this.getEffectiveBmwStatusText(_d);

        if (!name) {
            return defaultStage;
        }

        if (
            name.includes("delivered") ||
            name.includes("delivery complete") ||
            name.includes("departed unloading point")
        ) {
            return 7;
        }
        if (
            name.includes("arrival") ||
            name.includes("on site delivery") ||
            name.includes("arrived at delivery location")
        ) {
            return 6;
        }
        if (
            name.includes("border") ||
            name.includes("arrived at port / border") ||
            name.includes("departed port / border")
        ) {
            return 5;
        }
        // Departed loading point = we're in transit (stage 3)
        if (
            name.includes("departed loading") ||
            name.includes("departed loading point") ||
            name.includes("transit") ||
            (name.includes("departed") && !name.includes("unloading")) ||
            name.includes("boarded ferry / entered tunnel") ||
            name.includes("disembarked ferry / exited tunnel")
        ) {
            return 3;
        }
        // At departure step (about to depart or just sent "Depart collection point")
        if (name.includes("depart collection point") || name.includes("departure")) {
            return 2;
        }
        if (
            name.includes("collection") ||
            name.includes("pickup") ||
            name.includes("on site collection") ||
            name.includes("arrive at collection") ||
            name.includes("goods collected")
        ) {
            return 1;
        }

        return defaultStage;
    }

    private getEffectiveBmwStatusText(d?: TourModel | null): string {
        const name = this.getBmwStatusText(d);
        if (!this.isEtaRefreshStatus(name)) {
            return name;
        }

        return this.getPreviousNonEtaBmwStatusText();
    }

    private isEtaRefreshStatus(name: string): boolean {
        return name.includes("eta to collection") || name.includes("eta to delivery");
    }

    private getPreviousNonEtaBmwStatusText(): string {
        if (!this.bmwHistory?.length) {
            return "";
        }

        const sorted = [...this.bmwHistory].sort((a, b) => {
            const aTicks = new Date((a.updatedAt || a.date) as any).getTime();
            const bTicks = new Date((b.updatedAt || b.date) as any).getTime();
            return (Number.isNaN(bTicks) ? 0 : bTicks) - (Number.isNaN(aTicks) ? 0 : aTicks);
        });

        for (const item of sorted) {
            const status = [item?.updateType, item?.note]
                .filter((value): value is string => !!value && !!value.trim())
                .join(" ")
                .toLowerCase();

            if (!status) {
                continue;
            }

            if (!this.isEtaRefreshStatus(status)) {
                return status;
            }
        }

        return "";
    }

    private isDomesticOrderType(d?: TourModel | null): boolean {
        if (!d?.orderType) return false;
        return d.orderType.trim().toLowerCase() === "domestic";
    }

    /** Actions shown and sent for BMW jobs (domestic omits ferry + port/border). */
    private getBmwActionsForTour(): string[] {
        return this.isDomesticOrderType(this.detail)
            ? this.bmwDomesticActionSequence
            : this.bmwActionSequence;
    }

    /**
     * Next action index into {@link getBmwActionsForTour} for domestic jobs (status text only).
     * Checks most advanced status first.
     */
    private getNextDomesticBmwActionIndex(statusText: string): number {
        const s = statusText.toLowerCase();
        const len = this.bmwDomesticActionSequence.length;

        if (this.bmwDomesticStatusAliases[4].some((a) => s.includes(a))) {
            return len;
        }
        if (this.bmwDomesticStatusAliases[3].some((a) => s.includes(a))) {
            return 4;
        }
        if (this.bmwDomesticSkipAliases.some((a) => s.includes(a))) {
            return 3;
        }
        if (this.bmwDomesticStatusAliases[2].some((a) => s.includes(a))) {
            return 3;
        }
        if (this.bmwDomesticStatusAliases[1].some((a) => s.includes(a))) {
            return 2;
        }
        if (this.bmwDomesticStatusAliases[0].some((a) => s.includes(a))) {
            return 1;
        }
        return 0;
    }

    private getNextBmwActionIndex(): number {
        if (!this.detail) return 0;

        const actions = this.getBmwActionsForTour();
        const actionCount = actions.length;

        const statusText = this.getEffectiveBmwStatusText(this.detail);

        // If final delivery is recorded, there are no further actions.
        if (this.detail.actualDeliveryDate) {
            return actionCount;
        }

        // Use milestone dates as a stronger source of truth when available.
        // This prevents getting stuck on a previous label when updateType text lags.
        if (this.detail.actualArrivalAtDeliveryDate) {
            return 4;
        }
        //if (this.detail.actualDepartureFromCollectionDate) {
        //    return this.isDomesticOrderType(this.detail) ? 3 : 3;
        //}
        if (this.detail.actualDepartureFromCollectionDate) {
            return 3;
        }
        // if (this.detail.actualDepartureFromCollectionDate) {
        //     return this.isDomesticOrderType(this.detail) ? 3 : 3;
        // }

        if (this.detail.actualCollectionDate || this.detail.onsiteCollectionDateTime) {
            if (statusText.includes("goods collected") || statusText.includes("pickup")) {
                return 2;
            }

            if (
                statusText.includes("arrive at collection")
                || statusText.includes("arrived at collection")
                || statusText.includes("on site collection")
            ) {
                return 1;
            }
        }

        if (this.isDomesticOrderType(this.detail)) {
            return this.getNextDomesticBmwActionIndex(statusText);
        }

        const aliases: string[][] = [
            ["arrive at collection", "arrived at collection", "on site collection"],
            ["goods collected", "pickup complete", "pickup"],
            [
                "depart collection point",
                "departed loading point",
                "departed loading",
                "departure",
                "boarded ferry / entered tunnel",
                "boarded ferry",
                "entered tunnel",
                "disembarked ferry / exited tunnel",
                "disembarked ferry",
                "exited tunnel",
                "arrived at port / border",
                "arrived at border",
                "arrived at port",
                "port / border",
                "departed port / border",
                "departed border",
                "departed port",
                "at customs",
                "expected customs clearance",
                "customs arrival",
                "departed customs",
                "depart customs",
                "customs clearance"
            ],
            ["arrived at delivery location", "arrival", "on site delivery", "arrived at delivery"],
            ["delivered", "delivery complete", "departed unloading point"],
        ];

        const matchedIndex = aliases.findIndex((group) =>
            group.some((alias) => statusText.includes(alias))
        );

        if (matchedIndex >= 0) {
            return Math.min(matchedIndex + 1, this.bmwActionSequence.length);
        }

        // Fallback from the existing BMW stage derivation.
        const stage = this.bmwCurrentStageIndex;
        const stageToActionIndex: Record<number, number> = {
            0: 0,
            1: 0,
            2: 2,
            3: 3,
            4: 3,
            5: 3,
            6: 4,
            7: 5,
        };

        const stageToDomesticActionIndex: Record<number, number> = {
            0: 0,
            1: 0,
            2: 2,
            3: 3,
            4: 3,
            5: 3,
            6: 4,
            7: 5,
        };

        return this.isDomesticOrderType(this.detail)
            ? stageToDomesticActionIndex[stage] ?? 0
            : stageToActionIndex[stage] ?? 0;
    }

    /** Label for the single BMW action button based on current update type / stage. */
    get nextActionButtonLabel(): string {
        const actions = this.getBmwActionsForTour();
        const idx = this.getNextBmwActionIndex();
        if (idx >= actions.length) return "";
        return actions[idx] ?? "Update status";
    }

    get ferryActionButtonLabel(): string {
        if (!this.detail?.isBmwJob || this.isDomesticOrderType(this.detail)) {
            return "";
        }

        if (this.detail.actualDeliveryDate || this.detail.actualArrivalAtDeliveryDate) {
            return "";
        }

        const statusText = this.getBmwStatusText(this.detail);

        if (
            statusText.includes("disembarked ferry") ||
            statusText.includes("exited tunnel")
        ) {
            return "";
        }

        if (
            statusText.includes("boarded ferry") ||
            statusText.includes("entered tunnel")
        ) {
            return "Disembarked Ferry / Exited Tunnel";
        }

        return "Boarded Ferry / Entered Tunnel";
    }

    isFerryAction(actionLabel: string): boolean {
        return actionLabel === "Boarded Ferry / Entered Tunnel"
            || actionLabel === "Disembarked Ferry / Exited Tunnel";
    }

    get showCrossedBorderButton(): boolean {
        return !!this.detail?.isBmwJob;
    }

    get customsActionButtonLabel(): string {
        if (!this.detail?.isBmwJob) {
            return "";
        }

        const statusText = this.getBmwStatusText(this.detail);

        if (
            statusText.includes("departed customs") ||
            statusText.includes("depart customs") ||
            statusText.includes("customs clearance")
        ) {
            return "";
        }

        if (
            statusText.includes("at customs") ||
            statusText.includes("expected customs clearance") ||
            statusText.includes("customs arrival")
        ) {
            return "Departed Customs";
        }

        return "At Customs";
    }

    getTourHistoryUserDisplay(user: string | null | undefined): string {
        const value = (user || '').trim();
        if (!value) {
            return '';
        }

        return value === 'DriverIntUser' ? 'DriverAPP' : value;
    }

    /**
     * Filter tour history the same way as the audit history dialog so we show the same entries.
     */
    getFilteredBmwHistory(history: TourHistoryModel[] | null): TourHistoryModel[] {
        if (!history || !history.length) return [];

        const normalize = (value: string | null | undefined): string =>
            (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

        const terminalStatusOrder = new Map<string, number>([
            ['tracking ended', 0],
            ['departed unloading point', 1],
            ['pod received', 2],
        ]);

        const getTerminalRank = (updateType: string | null | undefined): number => {
            const normalized = normalize(updateType);
            return terminalStatusOrder.has(normalized)
                ? (terminalStatusOrder.get(normalized) as number)
                : Number.MAX_SAFE_INTEGER;
        };

        const baseFiltered = history.filter(
            (audit) =>
                audit.user !== "ImportService" &&
                audit.updateType !== "Escalation" &&
                audit.updateType !== "Hypercare" &&
                audit.updateType !== "Non-hypercare" &&
                audit.updateType !== "Tracking Frequency" &&
                !normalize(audit.updateType).includes('awaiting pod') &&
                ((!audit.requiresValidation && !audit.disabled) ||
                    (audit.approved === true && !audit.disabled) ||
                    (audit.approved === null &&
                        !audit.disabled &&
                        audit.user !== "ImportService"))
        );

        return [...baseFiltered].sort((a, b) => {
            const terminalRankA = getTerminalRank(a.updateType);
            const terminalRankB = getTerminalRank(b.updateType);
            if (terminalRankA !== terminalRankB) {
                return terminalRankA - terminalRankB;
            }

            const timeA = new Date(a.updatedAt as any).getTime();
            const timeB = new Date(b.updatedAt as any).getTime();
            if (Number.isNaN(timeA) && Number.isNaN(timeB)) {
                return 0;
            }
            if (Number.isNaN(timeA)) {
                return 1;
            }
            if (Number.isNaN(timeB)) {
                return -1;
            }
            return timeB - timeA;
        });
    }

    /** Paginated slice of filtered BMW history for the current page. */
    getPaginatedBmwHistory(history: TourHistoryModel[] | null): TourHistoryModel[] {
        const list = this.getFilteredBmwHistory(history);
        const start = this.bmwHistoryPageIndex * this.bmwHistoryPageSize;
        return list.slice(start, start + this.bmwHistoryPageSize);
    }

    onBmwHistoryPage(event: PageEvent): void {
        this.bmwHistoryPageIndex = event.pageIndex;
        this.bmwHistoryPageSize = event.pageSize;
    }

    /** Send consignment status via DriverTracking API (BMW action button). */
    sendConsignmentStatus(timeStampUtc?: string): void {
        if (!this.detail) return;
        const actions = this.getBmwActionsForTour();
        const idx = this.getNextBmwActionIndex();
        if (idx >= actions.length) return;
        const consignmentStatus = actions[idx] ?? "";
        this.sendConsignmentStatusByValue(consignmentStatus, timeStampUtc ?? new Date().toISOString());
    }

    private sendConsignmentStatusByValue(consignmentStatus: string, timeStampUtc: string, onSuccess?: () => void): void {
        if (!this.detail || !consignmentStatus) return;
        const consignmentNumber =
            this.detail.amcoId != null && this.detail.consignmentNumber != null
                ? `${this.detail.amcoId}.${this.detail.consignmentNumber}`
                : undefined;
        const command = new SendConsignmentStatusCommand({
            tourNumber: this.detail.tourNumber != null ? String(this.detail.tourNumber) : undefined,
            consignmentNumber,
            consignmentStatus,
            timeStampUtc,
            isWebUiRequest: true,
        });
        this.store.dispatch(new SendConsignmentStatusAction(command));
        this.actions$
            .pipe(ofActionSuccessful(SendConsignmentStatusSuccessAction), take(1))
            .subscribe(() => {
                this.cdr.detectChanges();
                this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
                if (this.detail?.isBmwJob && this.detail?.id != null) {
                    this.store.dispatch(new LoadTourUpdateHistoryAction(this.detail.id));
                }
                this.actions$
                    .pipe(ofActionSuccessful(GetTourByIdSuccessAction), take(1))
                    .subscribe((successAction: GetTourByIdSuccessAction) => {
                        if (successAction?.payload) {
                            this.detail = successAction.payload;
                            this.refreshDialogSubject.next();
                            this.cdr.detectChanges();
                        }
                    });

                if (onSuccess) {
                    onSuccess();
                }
            });
        this.actions$
            .pipe(ofActionSuccessful(SendConsignmentStatusFailAction), take(1))
            .subscribe(() => this.cdr.detectChanges());
    }

    confirmAndSendCrossedBorder(): void {
        if (!this.showCrossedBorderButton) return;
        this.openDatetimeDialogAndSendSpecificStatus("Crossed Border");
    }

    confirmAndSendFerryStatus(): void {
        if (!this.ferryActionButtonLabel) return;
        this.openDatetimeDialogAndSendSpecificStatus(this.ferryActionButtonLabel);
    }

    confirmAndSendCustomsStatus(): void {
        if (!this.customsActionButtonLabel) return;
        this.openDatetimeDialogAndSendSpecificStatus(this.customsActionButtonLabel);
    }

    /** Open datetime dialog, then send consignment status with the chosen datetime. */
    confirmAndSendConsignmentStatus(): void {
        if (!this.detail || !this.nextActionButtonLabel) return;

        // For "Goods Collected" we first ask the driver to confirm the goods count.
        if (this.nextActionButtonLabel === 'Goods Collected') {
            const goodsDialogRef = this.dialog.open(ReportParcelCountDiscrepancyDialogComponent, {
                width: '480px',
                data: {
                    tourNumber: this.detail.tourNumber != null ? String(this.detail.tourNumber) : undefined,
                    consignmentNumber: this.detail.consignmentNumber != null ? String(this.detail.consignmentNumber) : undefined,
                    expectedGoods: this.detail.expectedGoods ?? null,
                },
            });
            goodsDialogRef.afterClosed().subscribe((result: ReportParcelCountDiscrepancyDialogResult | undefined) => {
                if (result == null) return;
                if (result.hasDiscrepancy) {
                    this.reportParcelCountDiscrepancy(result.actualCount);
                }
                this.openDatetimeDialogAndSend();
            });
            return;
        }

        this.openDatetimeDialogAndSend();
    }

    /** Open the datetime confirmation dialog and then send the consignment status. */
    private openDatetimeDialogAndSend(onSuccess?: () => void): void {
        this.openDatetimeDialogAndSendSpecificStatus(this.nextActionButtonLabel, onSuccess);
    }

    private openDatetimeDialogAndSendSpecificStatus(actionLabel: string, onSuccess?: () => void): void {
        if (!actionLabel) return;

        const dialogRef = this.dialog.open(ConsignmentStatusDatetimeDialogComponent, {
            width: '400px',
            data: { actionLabel },
        });
        dialogRef.afterClosed().subscribe((timeStampUtc: string | undefined) => {
            if (timeStampUtc) {
                this.sendConsignmentStatusByValue(actionLabel, timeStampUtc, onSuccess);
            }
        });
    }

    /** Open the documents upload dialog for the current tour. */
    openDocumentsDialog(): void {
        if (!this.detail?.amcoId) return;
        this.dialog.open(ViewDocumentsDialogComponent, {
            width: '1500px',
            data: {
                id: this.detail.id,
                amcoId: this.detail.amcoId,
                consignmentNumber: this.detail.consignmentNumber,
            },
        });
    }

    openBmwChatsDialog(): void {
        if (!this.detail?.id || !this.detail?.amcoId) return;

        this.dialog.open(EscalationChatDialogComponent, {
            width: '650px',
            data: {
                id: this.detail.id,
                topic: 'BMW Job Chat',
                status: true,
                amcoId: this.detail.amcoId,
                prio: 'Low',
                isCustomsChat: false,
                isBmwChat: true,
                hasOpenChat: this.detail.hasOpenChat,
            },
        });
    }

    openReportParcelCountDiscrepancyDialog(): void {
        if (!this.detail) return;
        const dialogRef = this.dialog.open(ReportParcelCountDiscrepancyDialogComponent, {
            width: '480px',
            data: {
                tourNumber: this.detail.tourNumber != null ? String(this.detail.tourNumber) : undefined,
                consignmentNumber: this.detail.consignmentNumber != null ? String(this.detail.consignmentNumber) : undefined,
                expectedGoods: this.detail.expectedGoods ?? null,
            },
        });

        dialogRef.afterClosed().subscribe((result: ReportParcelCountDiscrepancyDialogResult | undefined) => {
            if (result == null) return;
            this.reportParcelCountDiscrepancy(result.actualCount);
        });
    }

    openInputLocationDialog(): void {
        if (!this.detail) return;
        const tour = this.detail;
        const dialogRef = this.dialog.open(UpdateEtaDialogComponent, {
            data: {
                tour,
                forceInputLocation: true,
                hasVehicle: !!tour.vehicleId,
                redirectBack: false,
                tourId: tour.tourId,
                updateTypeId: tour.updateTypeLookupId,
                updateTypeName: tour.updateTypeName,
                id: tour.id,
                amcoId: tour.amcoId,
                targetDate: tour.targetDateTime,
                aheadMinutes: tour.aheadMinutes,
                behindMinutes: tour.behindMinutes,
                plannedDeliveryStart: tour.plannedDeliveryStart,
                plannedDeliveryEnd: tour.plannedDeliveryEnd,
                plannedLoadingStart: tour.plannedLoadingStart,
                plannedLoadingEnd: tour.plannedLoadingEnd,
                vehicleTypes: tour.vechicleTypes,
            },
            width: '800px',
            disableClose: true,
        });

        // The dialog dispatches UpdateETAAction on submit; only a dispatched update triggers the toast/refresh.
        this.actions$
            .pipe(
                ofActionDispatched(UpdateETAAction),
                takeUntil(dialogRef.afterClosed()),
                take(1),
                switchMap(() =>
                    merge(
                        this.actions$.pipe(ofActionSuccessful(UpdateETASuccessAction), map(() => true)),
                        this.actions$.pipe(ofActionSuccessful(UpdateETAFailAction), map(() => false))
                    ).pipe(take(1))
                )
            )
            .subscribe((succeeded) => {
                if (!succeeded) {
                    this.snackBar.open('Failed to update location', 'Close', { duration: 5000 });
                    return;
                }
                this.snackBar.open('Location updated successfully', 'Close', { duration: 4000 });
                this.refreshAfterInputLocation();
            });
    }

    private refreshAfterInputLocation(): void {
        this.actions$
            .pipe(ofActionSuccessful(GetTourByIdSuccessAction), take(1))
            .subscribe((successAction: GetTourByIdSuccessAction) => {
                if (successAction?.payload) {
                    this.detail = successAction.payload;
                    this.refreshDialogSubject.next();
                    this.cdr.detectChanges();
                }
            });
        this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
        if (this.detail?.id != null) {
            this.store.dispatch(new LoadTourUpdateHistoryAction(this.detail.id));
        }
    }

    openReportDelayDialog(): void {
        if (!this.detail) {
            return;
        }

        this.isReportingDelay = true;
        this.lookupsClient.getDelayReasons().pipe(take(1)).subscribe({
            next: (reasons: LookupModel[] | null) => {
                this.isReportingDelay = false;
                const validReasons = (reasons || []).filter((x) => x?.id != null && !!x?.name);
                if (!validReasons.length) {
                    this.cdr.detectChanges();
                    return;
                }

                const dialogRef = this.dialog.open(ReportDelayDialogComponent, {
                    width: '520px',
                    data: {
                        reasons: validReasons,
                        title: 'Report Delay',
                    },
                });

                dialogRef.afterClosed().pipe(take(1)).subscribe((selectedReasonCode: number | undefined) => {
                    if (selectedReasonCode == null) {
                        return;
                    }

                    this.reportDelay(selectedReasonCode);
                });
            },
            error: () => {
                this.isReportingDelay = false;
                this.cdr.detectChanges();
            },
        });
    }

    private reportParcelCountDiscrepancy(actualCount: number): void {
        if (!this.detail) return;
        const consignmentNumber =
            this.detail.amcoId != null && this.detail.consignmentNumber != null
                ? `${this.detail.amcoId}.${this.detail.consignmentNumber}`
                : undefined;
        const command = new ReportParcelCountDiscrepancyCommand({
            tourNumber: this.detail.tourNumber != null ? String(this.detail.tourNumber) : undefined,
            consignmentNumber,
            actualGoods: actualCount,
        });

        this.store.dispatch(new ReportParcelCountDiscrepancyAction(command));
        this.actions$
            .pipe(ofActionSuccessful(ReportParcelCountDiscrepancySuccessAction), take(1))
            .subscribe(() => {
                this.cdr.detectChanges();
                this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
                if (this.detail?.isBmwJob && this.detail?.id != null) {
                    this.store.dispatch(new LoadTourUpdateHistoryAction(this.detail.id));
                }
            });
        this.actions$
            .pipe(ofActionSuccessful(ReportParcelCountDiscrepancyFailAction), take(1))
            .subscribe(() => this.cdr.detectChanges());
    }

    private reportDelay(delayReasonCode: number): void {
        if (!this.detail) {
            return;
        }

        if (this.detail.amcoId == null || this.detail.tourId == null || !this.detail.transportOrderNumber) {
            this.cdr.detectChanges();
            return;
        }

        this.isReportingDelay = true;

        const command = new ReportDelayCommand({
            amcoId: this.detail.amcoId,
            tourId: this.detail.tourId,
            transportOrderNumber: this.detail.transportOrderNumber,
            delayReasonCode,
            timeStampUtc: new Date().toISOString(),
        });

        this.driverTrackingClient.reportDelay(command).pipe(take(1)).subscribe({
            next: () => {
                this.isReportingDelay = false;
                this.cdr.detectChanges();
                this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
                if (this.detail?.isBmwJob && this.detail?.id != null) {
                    this.store.dispatch(new LoadTourUpdateHistoryAction(this.detail.id));
                }
            },
            error: () => {
                this.isReportingDelay = false;
                this.cdr.detectChanges();
            },
        });
    }

    private loadBmwGeofences(showAfterLoad: boolean, replayAfterLoad = false): void {
        this.isLoadingBmwGeofences = true;
        this.cdr.detectChanges();

        this.historyClient.getGeofenceLocations().pipe(take(1)).subscribe({
            next: (zones) => {
                this.geofenceZones = zones || [];
                this.hasLoadedBmwGeofences = true;
                this.showBmwGeofences = showAfterLoad;
                this.isLoadingBmwGeofences = false;

                if (replayAfterLoad) {
                    this.executeBmwGeofencingReplay();
                    return;
                }

                this.cdr.detectChanges();
            },
            error: () => {
                this.geofenceZones = [];
                this.hasLoadedBmwGeofences = false;
                this.showBmwGeofences = false;
                this.isLoadingBmwGeofences = false;
                this.cdr.detectChanges();
            },
        });
    }

    private executeBmwGeofencingReplay(): void {
        if (!this.detail?.id) {
            return;
        }

        this.isReplayingBmwGeofencing = true;
        this.cdr.detectChanges();

        this.historyClient.replayGeofencing(this.detail.id).pipe(take(1)).subscribe({
            next: (markers) => {
                this.replayMarkers = markers || [];
                this.selectedReplayMarkerIndex = null;
                this.selectedMapFocus = null;
                this.hasBmwReplayResult = true;
                this.isReplayingBmwGeofencing = false;
                this.cdr.detectChanges();
            },
            error: () => {
                this.replayMarkers = [];
                this.selectedReplayMarkerIndex = null;
                this.selectedMapFocus = null;
                this.hasBmwReplayResult = true;
                this.isReplayingBmwGeofencing = false;
                this.cdr.detectChanges();
            },
        });
    }

    private getFocusZoomForMilestone(milestoneName: string | undefined): number {
        if (this.isBorderCrossed(milestoneName)) {
            return 8;
        }

        if (this.isTunnelMilestone(milestoneName)) {
            return 11;
        }

        return 10;
    }

    private focusMap(lat: number, lng: number, zoom: number): void {
        this.bmwMapZoom = zoom;

        if (this.bmwMapInstance?.panTo && this.bmwMapInstance?.setZoom) {
            this.bmwMapInstance.panTo({ lat, lng });
            this.bmwMapInstance.setZoom(zoom);
            return;
        }

        this.pendingMapFocus = { lat, lng, zoom };
    }
}
